const tickerItems = [
  "Free US Shipping on 2+ Jerseys",
  "All 32 Teams In Stock",
  "Stitched Numbers & Names",
  "2-Day Dispatch",
  "Game-Day Ready",
];

export const Ticker = () => (
  <div className="relative overflow-hidden bg-[#39FF14] py-2" data-testid="ct-ticker" aria-hidden="true">
    <div className="marquee-track flex w-max items-center whitespace-nowrap" style={{ animationDuration: "30s" }}>
      {[...tickerItems, ...tickerItems, ...tickerItems].map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-['Barlow_Condensed',sans-serif] text-sm font-bold uppercase tracking-widest text-[#07090E] px-6">{item}</span>
          <span className="text-[#07090E]">★</span>
        </span>
      ))}
    </div>
  </div>
);

export default function CleanTeamHeader() {
  return (
    <header className="sticky top-0 z-50" data-testid="ct-header">
      <div className="bg-[#07090E]/85 backdrop-blur-md border-b border-white/10">
        <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto flex items-center justify-between h-16">
          <a href="#top" className="flex items-center gap-2.5" data-testid="ct-logo">
            <span className="w-9 h-9 rounded-lg bg-[#39FF14] flex items-center justify-center font-['Barlow_Condensed',sans-serif] font-black text-[#07090E] text-lg leading-none">CT</span>
            <span className="font-['Barlow_Condensed',sans-serif] text-2xl font-extrabold uppercase tracking-wide text-white">Clean <span className="text-[#39FF14]">Team</span></span>
          </a>
          <nav className="hidden md:flex items-center gap-8 text-sm font-semibold uppercase tracking-wider text-white/60">
            <a href="#teams" className="hover:text-[#39FF14] transition-colors">Teams</a>
            <a href="#quality" className="hover:text-[#39FF14] transition-colors">Quality</a>
            <a href="#shipping" className="hover:text-[#39FF14] transition-colors">Shipping</a>
          </nav>
          <a href="#teams" data-testid="ct-header-shop-btn"
            className="bg-[#39FF14] text-[#07090E] text-sm font-bold uppercase tracking-wider px-5 py-2.5 rounded-full hover:bg-[#5CFF3D] hover:-translate-y-0.5 transition-all duration-300">
            Shop Jerseys
          </a>
        </div>
      </div>
      <Ticker />
    </header>
  );
}
